import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err: unknown) => {
        const status = (err as { status?: number } | null)?.status;
        if (status && [401, 403, 404].includes(status)) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});
